import { PriceRangeFilterState } from './priceRange.types';

export const getDefaultPriceRangeFilter = (): PriceRangeFilterState => ({
  priceRange: {
    0: true, // All ranges
  },
});
export const defaultPriceRangeFilter = getDefaultPriceRangeFilter();
